export default __webpack_public_path__ + "static/media/CJquery.ba50b74c.jpg";